import { render, staticRenderFns } from "./FrequencySelection.vue?vue&type=template&id=35ada141&"
import script from "./FrequencySelection.vue?vue&type=script&lang=js&"
export * from "./FrequencySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports